import Vue from 'vue'
import Startup from './components/Startup'
import Corporate from './components/Corporate'
import Map from './components/Map'
import Smart from './components/Smart'
import About from './components/About'
import Future from './components/Future'
import Privacy from './components/Privacy'
import Impressum from './components/Impressum'
import App from './App'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
Vue.use(VueHead)
Vue.use(VueRouter)
const routes = [
  { path: '/startup-innovation', component: Startup },
  { path: '/corporate-innovation', component: Corporate },
  { path: '/smart-energy-systems', component: Smart },
  { path: '/future-energy-system', component: Future },
  { path: '/contact-about', component: About },
  { path: '/cleantech-startup-map', component: Map },
  { path: '/impressum', component: Impressum },
  { path: '/privacy', component: Privacy }
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  mode: 'history',
  routes
})

// 4. Create and mount the root instance.
// Make sure to inject the router with the router option to make the
// whole app router-aware.
/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js